{
  "tabs": {
    "chat": "Sgwrs",
    "reminders": "Atgoffion",
    "calendar": "Calendr",
    "settings": "Gosodiadau"
  },
  "common": {
    "cancel": "Canslo",
    "save": "Cadw",
    "confirm": "Cadarnhau",
    "delete": "Dileu",
    "back": "Yn ôl",
    "close": "Cau",
    "edit": "Golygu",
    "search": "Chwilio",
    "all": "Pawb",
    "loading": "Wrthi'n llwytho...",
    "error": "Digwyddodd gwall",
    "notFound": "Heb ddod o hyd",
    "tryAgain": "Rhowch gynnig arall arni",
    "retry": "Ceisio eto",
    "undo": "Dadwneud",
    "pullToRefresh": "Tynnu i adnewyddu",
    "justNow": "yn awr"
  },
  "auth": {
    "welcome": "Croeso i FishMemory",
    "tagline": "Eich cynorthwyydd atgoffa WhatsApp, yn awr yn eich poced.",
    "subtitle": "Eich cynorthwyydd atgoffa WhatsApp, yn awr yn eich poced.",
    "phoneLabel": "Eich rhif WhatsApp",
    "phoneHint": "Anfonwn god dilysu drwy WhatsApp",
    "invalidPhone": "Rhowch rif ffôn dilys",
    "continue": "Parhau",
    "enterPhone": "Rhowch eich rhif WhatsApp",
    "phonePlaceholder": "Rhif ffôn",
    "sendCode": "Anfon Cod",
    "verifyTitle": "Dilysu eich rhif",
    "otpSentTo": "Cod 6-digid wedi'i anfon at {{phone}} drwy WhatsApp",
    "enterFullCode": "Rhowch yr 6 digid i gyd",
    "invalidOtp": "Cod annilys. Rhowch gynnig arall arni.",
    "otpFailed": "Methwyd anfon y cod. Ceisiwch eto.",
    "otpResent": "Cod wedi'i anfon eto",
    "resendIn": "Anfon eto mewn {{seconds}}s",
    "resendCode": "Anfon cod eto",
    "enterOtp": "Rhowch y cod a anfonwyd i'ch WhatsApp",
    "verify": "Dilysu",
    "resend": "Anfon cod eto",
    "wrongNumber": "Rhif anghywir?",
    "backToPhone": "Yn ôl i'r ffôn",
    "editPhone": "Golygu rhif ffôn",
    "error": "Gwall",
    "setupTitle": "Gadewch i ni sefydlu",
    "setupSubtitle": "Gallwch newid hyn unrhyw bryd yn y Gosodiadau",
    "namePlaceholder": "Eich enw",
    "letsGo": "Gorffen sefydlu",
    "skipForNow": "Neidio dros hyn"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Teipiwch neges...",
    "inputPlaceholder": "Teipiwch neges...",
    "typing": "Mae FishMemory yn teipio...",
    "online": "Ar-lein",
    "connecting": "Yn cysylltu...",
    "reconnecting": "Yn ailgysylltu...",
    "offline": "All-lein",
    "empty": "Dechreuwch sgwrs",
    "emptyHint": "Creu atgoffion, gwirio eich amserlen, neu ofyn am help.",
    "emptyAction": "Anfon atgoffa sampl",
    "actions": "Gweithredoedd sgwrs",
    "keep": "Cadw negeseuon",
    "clearTitle": "Clirio sgwrs",
    "clearConfirm": "Dileu pob neges o'r ddyfais hon? Ni ellir dadwneud hyn.",
    "clear": "Clirio sgwrs",
    "optionSelected": "Wedi dewis: {{label}}",
    "sendingSelection": "Yn anfon...",
    "connectionLost": "Yn ailgysylltu..."
  },
  "reminders": {
    "title": "Fy Atgoffion",
    "active": "Yn weithredol",
    "today": "Heddiw",
    "thisWeek": "Yr Wythnos Hon",
    "history": "Hanes",
    "items": "eitemau",
    "emptyTitle": "Dim atgoffion eto",
    "emptySubtitle": "Creu un o'r sgwrs a bydd yn ymddangos yma.",
    "emptyAction": "Agor sgwrs",
    "filterActive": "Yn weithredol",
    "filterToday": "Heddiw",
    "filterWeek": "Yr Wythnos Hon",
    "filterHistory": "Hanes",
    "emptyState": "Dim atgoffion eto. Dechreuwch sgwrsio!",
    "swipeDone": "Wedi Gorffen",
    "swipeSnooze": "Snooze",
    "swipeDelete": "Dileu",
    "search": "Chwilio atgoffion...",
    "upcoming": "Yn dod",
    "completed": "Wedi'i gwblhau",
    "overdue": "Dros ben amser",
    "tomorrow": "Yfory",
    "synced": "Cysonwyd {{value}}",
    "swipeHint": "Sleidwch atgoffa am fwy o weithredoedd",
    "noResults": "Dim atgoffion yn cyfateb i'ch chwiliad",
    "noResultsHint": "Rhowch allweddair gwahanol neu glirio'r chwiliad",
    "deleteAllFailed": "Methwyd dileu pob atgoffa"
  },
  "calendar": {
    "title": "Calendr",
    "today": "Heddiw",
    "tomorrow": "Yfory",
    "completed": "wedi gorffen",
    "noEvents": "Dim digwyddiadau wedi'u trefnu",
    "noEventsSubtitle": "Dewiswch ddyddiad i weld atgoffion a digwyddiadau calendr.",
    "googleEvent": "Calendr Google",
    "legendActive": "Yn weithredol",
    "legendRecurring": "Yn ailadrodd",
    "legendDone": "Wedi gorffen",
    "legendGoogle": "Google",
    "previousMonth": "Mis blaenorol",
    "nextMonth": "Mis nesaf",
    "previousYear": "Blwyddyn flaenorol",
    "nextYear": "Blwyddyn nesaf",
    "goToToday": "Ewch i heddiw",
    "all": "Pawb",
    "active": "Yn weithredol",
    "done": "Wedi gorffen",
    "paused": "Wedi atal"
  },
  "settings": {
    "title": "Gosodiadau",
    "profile": "Proffil",
    "name": "Enw arddangos",
    "enterName": "Rhowch eich enw",
    "language": "Iaith",
    "uiLanguage": "Iaith yr app",
    "uiLanguageHelp": "Newid iaith y rhyngwyneb, labeli calendr, a chyfeiriad y cynllun ar y ddyfais hon yn unig.",
    "serverLanguage": "Iaith y sgwrs",
    "serverLanguageHelp": "Newid iaith y ymatebion gweinydd a negeseuon atgoffa ar gyfer eich cyfrif.",
    "timezone": "Parth amser",
    "currentTimezone": "Parth amser presennol",
    "timezoneHelp": "Mae pob amser atgoffa yn cael ei ddangos gan ddefnyddio'r parth amser hwn.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Cadw parth amser",
    "timezoneSaved": "Parth amser wedi'i ddiweddaru",
    "detect": "Canfod",
    "detectFailed": "Methwyd canfod parth amser",
    "autoDetect": "Canfod awtomatig o GPS",
    "notifications": "Hysbysiadau",
    "notificationsHelp": "Rheolaethau atgoffa dilynol sy'n rheoli rhybuddion ailadroddus ar ôl i atgoffa gael ei gyflwyno. Mae caniatâd hysbysiadau ar lefel y ddyfais yn cael eu rheoli yn eich gosodiadau ffôn.",
    "pushEnabled": "Hysbysiadau Push",
    "autoDoneOnFire": "Marcio'n awtomatig fel wedi'i gwblhau pan fydd yn tanio",
    "autoDoneOnFireDesc": "Pan fydd wedi'i ddiffodd, mae atgoffion yn aros yn weithredol nes i chi eu marcio fel wedi'u cwblhau.",
    "googleCalendar": "Calendr Google",
    "google": "Calendr Google",
    "googleConnected": "Wedi cysylltu",
    "googleDisconnected": "Heb gysylltu",
    "googleConnectedHelp": "Gall atgoffion newydd gael eu cysoni i'ch calendr yn awtomatig.",
    "googleDisconnectedHelp": "Cysylltwch Calendr Google i gadw atgoffion a digwyddiadau'n cyd-fynd.",
    "googleConnectFailed": "Methwyd cysylltu Calendr Google",
    "connected": "Wedi cysylltu",
    "disconnected": "Heb gysylltu",
    "connect": "Cysylltu",
    "disconnect": "Datgysylltu",
    "autoSync": "Cysoni atgoffion newydd yn awtomatig",
    "autosync": "Cysoni atgoffion newydd yn awtomatig",
    "subscription": "Tanysgrifiad",
    "trialUsed": "Treial: {{used}}/{{total}} wedi'i ddefnyddio",
    "trialStatus": "Treial ar gael",
    "activeStatus": "Tanysgrifiad yn weithredol",
    "expiredStatus": "Tanysgrifiad wedi dod i ben",
    "unsubscribedStatus": "Heb danysgrifio",
    "about": "Amdano",
    "version": "Fersiwn",
    "logout": "Allgofnodi",
    "logoutTitle": "Allgofnodi",
    "logoutConfirm": "Ydych chi'n siŵr eich bod am allgofnodi?",
    "noName": "Dim enw wedi'i osod",
    "serverConnection": "Cysylltiad gweinydd",
    "serverUrl": "URL y gweinydd",
    "serverEdit": "Golygu",
    "saveReconnect": "Cadw a chysylltu eto",
    "resetDefault": "Ailosod i'r diofyn",
    "invalidServerUrlTitle": "URL gweinydd annilys",
    "invalidServerUrlMessage": "Rhowch URL gweinydd http neu https dilys, er enghraifft https://example.com",
    "uiLanguageChangeFailed": "Methwyd newid iaith yr app. Rhowch gynnig arall arni.",
    "serverLanguageChangeFailed": "Methwyd newid iaith y sgwrs. Rhowch gynnig arall arni.",
    "timezoneChangeFailed": "Methwyd newid parth amser. Rhowch gynnig arall arni.",
    "autoSyncChangeFailed": "Methwyd diweddaru cysoniad awtomatig. Rhowch gynnig arall arni.",
    "nameChangeFailed": "Methwyd diweddaru enw arddangos. Rhowch gynnig arall arni.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Manylion atgoffa",
    "editTime": "Golygu Amser",
    "rename": "Ailenwi",
    "snooze": "Snooze",
    "snooze15": "Snooze 15 munud",
    "pause": "Atal",
    "pauseReminder": "Atal atgoffa",
    "resume": "Ailgychwyn",
    "resumeReminder": "Ailgychwyn atgoffa",
    "skip": "Neidio Nesaf",
    "skipOccurrence": "Neidio dros y digwyddiad hwn",
    "syncGoogle": "Cysoni i Google",
    "delete": "Dileu",
    "deleteTitle": "Dileu Atgoffa",
    "deleteConfirm": "Bydd yr atgoffa hwn yn cael ei ddileu'n barhaol.",
    "deleteRecurringTitle": "Dileu Atgoffa Ailadroddus",
    "deleteRecurringMessage": "Ydych chi am neidio dros y digwyddiad hwn neu ddileu'r gyfres gyfan?",
    "deleteThisOccurrence": "Neidio dros y digwyddiad hwn",
    "deleteEntireSeries": "Dileu'r gyfres gyfan",
    "done": "Wedi Gorffen",
    "markDone": "Marcio fel wedi'i gwblhau",
    "undo": "Adfer",
    "undoPrompt": "Ei angen yn weithredol eto? Adferwch ef nawr.",
    "recurring": "Ailadroddus",
    "nextRun": "Rhedeg nesaf",
    "oneTime": "Unwaith",
    "pending": "Yn aros",
    "sent": "Anfonwyd",
    "paused": "Wedi atal",
    "active": "Yn weithredol",
    "snoozed": "Wedi snooze",
    "localTime": "Wedi'i ddangos yn eich amser lleol",
    "recurrence": "Ailadrodd",
    "created": "Wedi creu",
    "tags": "Tagiau",
    "fireCount": "Amseroedd wedi tanio",
    "actions": "Gweithredoedd",
    "none": "Dim",
    "snoozeFailed": "Methwyd snooze atgoffa",
    "pauseFailed": "Methwyd atal atgoffa",
    "resumeFailed": "Methwyd ailgychwyn atgoffa",
    "skipFailed": "Methwyd neidio atgoffa",
    "doneFailed": "Methwyd marcio atgoffa fel wedi'i gwblhau",
    "undoFailed": "Methwyd adfer statws atgoffa",
    "deleteFailed": "Methwyd dileu atgoffa",
    "rescheduleTitle": "Ail-drefnu?",
    "rescheduleMsg": "Mae'r atgoffa hwn wedi mynd dros ben amser. Hoffech chi ei ail-drefnu?",
    "reschedule15": "Mewn 15 munud",
    "reschedule60": "Mewn 1 awr",
    "keepOverdue": "Cadw fel y mae"
  },
  "onboarding": {
    "slide1Title": "Croeso i FishMemory",
    "slide1Sub": "Eich cynorthwyydd atgoffa personol — wedi'i bweru gan WhatsApp ac wedi'i adeiladu ar gyfer eich poced.",
    "slide2Title": "Sgwrsio'n naturiol",
    "slide2Sub": "Teipiwch atgoffion fel rydych chi'n meddwl: \"Atgoffwch fi i ffonio mam yfory am 3pm\" — rydym ni'n gofalu am y gweddill.",
    "slide3Title": "Peidiwch byth â cholli dim",
    "slide3Sub": "Derbyn hysbysiadau prydlon, trefnu gyda tagiau, a chadw rheolaeth ar bopeth sy'n bwysig.",
    "getStarted": "Dechrau",
    "next": "Nesaf",
    "firstReminderTitle": "Creu eich atgoffa cyntaf!",
    "firstReminderHint": "Ceisiwch deipio rhywbeth fel:",
    "firstReminderExample": "Atgoffwch fi i yfed dŵr yfory am 9 AM",
    "gotIt": "Deall!",
    "notifRationaleTitle": "Arhoswch ar amser",
    "notifRationaleBody": "Mae FishMemory angen hysbysiadau i'ch atgoffa ar amser. Dim ond rhybuddion ar gyfer atgoffion a grëwyd gennych fyddwch yn eu derbyn.",
    "notifRationaleAllow": "Galluogi Hysbysiadau",
    "notifRationaleLater": "Efallai'n Hwyr",
    "swipeHint": "Sleidwch i'r dde am weithredoedd cyflym →",
    "calendarDragHint": "Tynnu i ehangu ↕"
  }
}
